/**
 * Tiny SVG of a rebar piece — used everywhere we mention "fierros".
 *
 * Drawn as a horizontal bar with diagonal corrugations (the lugs that
 * make rebar grip concrete). Pure SVG, no library cost; inherits color
 * from `currentColor` so callers can theme it via CSS.
 */
export function FierroIcon({ size = 14 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      aria-hidden
    >
      {/* Main bar */}
      <rect
        x="1.5"
        y="6"
        width="13"
        height="4"
        rx="1.2"
        strokeWidth="1.3"
      />
      {/* Corrugation marks */}
      <line x1="3.5" y1="6" x2="2.7" y2="10" strokeWidth="0.9" />
      <line x1="6.0" y1="6" x2="5.2" y2="10" strokeWidth="0.9" />
      <line x1="8.5" y1="6" x2="7.7" y2="10" strokeWidth="0.9" />
      <line x1="11.0" y1="6" x2="10.2" y2="10" strokeWidth="0.9" />
      <line x1="13.5" y1="6" x2="12.7" y2="10" strokeWidth="0.9" />
    </svg>
  );
}
